import { getApiUrl, getJwtKey, UploadCodeListFileCommandResult } from "./Api";

export enum ActionType {
	InfoWarningCreate = 0,
	InfoWarningDeleteByDescription = 1,
	CacheRefresh = 2,
	SystemSettingSave = 3,
	FeatureEnableDisable = 4,
	FeatureUpdate = 5,
	ProductEnableDisable = 6,
}

export type UploadCodeListFileParams = {
	file: File;
	folderPath: string;
};

export async function uploadCodeListFile(
	params: UploadCodeListFileParams
): Promise<UploadCodeListFileCommandResult> {
	const token = getJwtKey();
	const formData = new FormData();
	formData.append("file", params.file);
	formData.append("folderPath", params.folderPath);

	const response = await fetch(
		`${getApiUrl()}/api/v1/codelist-management/files`,
		{
			method: "POST",
			headers: {
				...(token ? { Authorization: token } : {}),
			},
			body: formData,
		}
	);

	if (!response.ok) {
		const errorData = await response.json().catch(() => ({}));
		throw new Error(errorData.detail || "Failed to upload file");
	}

	return await response.json();
}

export async function exportDevices(payload: any) {
	const token = getJwtKey();
	try {
		const response = await fetch(`${getApiUrl()}/api/v1/devices/export`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...(token ? { Authorization: token } : {}),
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			throw new Error("Failed to download file");
		}

		return await response.blob();
	} catch (error) {
		console.error("Error downloading file:", error);
		throw error;
	}
}
